import React from 'react';
import { WrapperButtonsLinksStyle } from './style';

export default function WrapperButtonsLinks({ year, setYear }) {
  return (
    <WrapperButtonsLinksStyle>
      <button
        id={year === '20' ? 'active' : 'disable'}
        onClick={() => {
          setYear('20');
        }}
      >
        2020
      </button>
      <button
        id={year === '21' ? 'active' : 'disable'}
        onClick={() => {
          setYear('21');
        }}
      >
        2021
      </button>
    </WrapperButtonsLinksStyle>
  );
}
